document.addEventListener('DOMContentLoaded', function() {
  const secondHeader = document.querySelector('.ai-header-scroll-aa3viog5xzxpmbhh4naigenblock87a1b89p9g89v');
  
  if (secondHeader) {
    // Hide initially
    secondHeader.style.opacity = '0';
    secondHeader.style.pointerEvents = 'none';
    secondHeader.style.transition = 'opacity 0.3s ease';
    secondHeader.style.position = 'fixed';
    secondHeader.style.top = '0';
    secondHeader.style.width = '100%';
    secondHeader.style.zIndex = '1000';
    
    window.addEventListener('scroll', function() {
      if (window.scrollY >= 400) {
        secondHeader.style.opacity = '1';
        secondHeader.style.pointerEvents = 'auto';
      } else {
        secondHeader.style.opacity = '0';
        secondHeader.style.pointerEvents = 'none';
      }
    });
  }
});
